import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=b5b85e3a&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5b85e3a')) {
      api.createRecord('b5b85e3a', component.options)
    } else {
      api.reload('b5b85e3a', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=b5b85e3a&", function () {
      api.rerender('b5b85e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20RYvcIVcSRAK/JS/comp/IncreaseNumber.vue"
export default component.exports